import {PdfEvalueringStatistikHeaderComponent} from "core/components/pdf/pdfHeaders/pdfEvalueringStatistikHeaderComponent";
import { PdfReadySignal } from "./components/pdfReadySignal";
import {Localizer} from "infrastructure/localization/localizer";
import {LocalizerPageSpecifics} from "infrastructure/localization/localizerPageSpecifics";
import {useEffect, useState} from "react";
import {useRouteMatch} from "react-router-dom";
import {EvalueringPdfModel} from "../../../core/sharedmodels/evaluering/evalueringPdfModel";
import PdfComponent from "core/components/pdf/components/pdfComponent";
import {useFetchWithErrorHandlingPdf} from "./hooks/useFetchWithErrorHandlingPdf";
import useLogbogApi from "../../hooks/useLogbogApi";

export function EvalueringStatistikPdf() {
    const [forloebEvaluering, setForloebEvaluering] = useState<EvalueringPdfModel>()
    const [dataLoaded, setDataLoaded] = useState(false);

    const routeMatch = useRouteMatch();
    const routeParams = (routeMatch.params as { forloebEvalueringId: string });

    const setError = useFetchWithErrorHandlingPdf();
    const { forloebEvalueringApi } = useLogbogApi();

    useEffect(() => {
        const fetch = async () => {
            const evaluering = await forloebEvalueringApi.getForloebEvalueringForPdf(routeParams.forloebEvalueringId);
            setForloebEvaluering(evaluering);
            setDataLoaded(true);
        };
        fetch().catch(err => setError(err));
    }, [forloebEvalueringApi, routeParams.forloebEvalueringId, setError])

    return (
        <PdfComponent>
            <PdfEvalueringStatistikHeaderComponent evaluering={forloebEvaluering}/>

            <PdfComponent.BlockItem className={"card"}>
                {forloebEvaluering?.svar &&
                    forloebEvaluering.svar.map((s, i) =>
                        <PdfComponent.NonBreakableItem className={"card-body"}>
                                <div className={"flex-container-row align-content-center"}>
                                    <div className={"col-4 pdf-list-row-column-item-center"}>{`${i+1}. ${s.spoergsmaal}`}</div>
                                    <div className={"col-8 pdf-list-row-column-item-center"}>{s.ikkeRelevant ? Localizer.global_notRelevant() : s.svarState}</div>
                                </div>
                                {s.kommentar !== null &&
                                <div className={"card-body"}>
                                    <div className={"flex-container-row align-content-center"}>
                                        <div className={"col-4 pdf-list-row-column-item-center"}>{LocalizerPageSpecifics.evalueringPdf_Kommentar()}</div>
                                        <div className={"col-8 pdf-list-row-column-item-center"}>{s.kommentar}</div>
                                    </div>
                                </div>}
                        </PdfComponent.NonBreakableItem>
                    )
                }
            </PdfComponent.BlockItem>

            <PdfReadySignal when={dataLoaded} />
        </PdfComponent>
    );
}
